import React from 'react';
export function WhatYouGet() {
  return <section className="w-full py-20 px-6" style={{
    backgroundColor: '#F5F0EB'
  }} data-id="element-264">
      <div className="max-w-4xl mx-auto" data-id="element-265">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-266">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase mb-4" style={{
          color: '#FF5A5F',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-267">
            Lo que incluye
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight" style={{
          color: '#1A1A1A',
          fontFamily: 'Plus Jakarta Sans, sans-serif'
        }} data-id="element-268">
            Todo lo que obtienes hoy
          </h2>
        </div>

        {/* Deliverables */}
        <div className="space-y-5" data-id="element-269">
          {/* Item 1 */}
          <div className="flex items-start gap-5 bg-white rounded-2xl p-6 shadow-sm border border-[#E8E0D8]" data-id="element-270">
            <div className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center text-2xl" style={{
            backgroundColor: '#FFF0F0'
          }} role="img" aria-label="Protocolo" data-id="element-271">
              💬
            </div>
            <div data-id="element-272">
              <h3 className="text-lg font-bold mb-1" style={{
              color: '#1A1A1A',
              fontFamily: 'Plus Jakarta Sans, sans-serif'
            }} data-id="element-273">
                Protocolo de Comunicación Asíncrona
              </h3>
              <p style={{
              color: '#6B7280',
              fontFamily: 'Inter, sans-serif'
            }} className="text-base leading-relaxed" data-id="element-274">
                El guion exacto de bienvenida, seguimiento y despedida. Copia,
                pega y personaliza en minutos.
              </p>
            </div>
          </div>

          {/* Item 2 */}
          <div className="flex items-start gap-5 bg-white rounded-2xl p-6 shadow-sm border border-[#E8E0D8]" data-id="element-275">
            <div className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center text-2xl" style={{
            backgroundColor: '#FFF0F0'
          }} role="img" aria-label="Check-in" data-id="element-276">
              🗝️
            </div>
            <div data-id="element-277">
              <h3 className="text-lg font-bold mb-1" style={{
              color: '#1A1A1A',
              fontFamily: 'Plus Jakarta Sans, sans-serif'
            }} data-id="element-278">
                Guía de Check-in Visual
              </h3>
              <p style={{
              color: '#6B7280',
              fontFamily: 'Inter, sans-serif'
            }} className="text-base leading-relaxed" data-id="element-279">
                Plantilla para que el huésped entre a la propiedad sin una sola
                llamada. Incluye instrucciones paso a paso con espacio para tus
                fotos.
              </p>
            </div>
          </div>

          {/* Item 3 */}
          <div className="flex items-start gap-5 bg-white rounded-2xl p-6 shadow-sm border border-[#E8E0D8]" data-id="element-280">
            <div className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center text-2xl" style={{
            backgroundColor: '#FFF0F0'
          }} role="img" aria-label="Manual" data-id="element-281">
              📋
            </div>
            <div data-id="element-282">
              <h3 className="text-lg font-bold mb-1" style={{
              color: '#1A1A1A',
              fontFamily: 'Plus Jakarta Sans, sans-serif'
            }} data-id="element-283">
                Manual de la Casa "Sin Fricción"
              </h3>
              <p style={{
              color: '#6B7280',
              fontFamily: 'Inter, sans-serif'
            }} className="text-base leading-relaxed" data-id="element-284">
                Reglas claras que protegen tu propiedad y evitan multas.
                Redactado para que el huésped lo lea y entienda sin sentirse
                juzgado.
              </p>
            </div>
          </div>

          {/* Item 4 */}
          <div className="flex items-start gap-5 bg-white rounded-2xl p-6 shadow-sm border border-[#E8E0D8]" data-id="element-285">
            <div className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center text-2xl" style={{
            backgroundColor: '#FFF0F0'
          }} role="img" aria-label="Reseñas" data-id="element-286">
              ⭐
            </div>
            <div data-id="element-287">
              <h3 className="text-lg font-bold mb-1" style={{
              color: '#1A1A1A',
              fontFamily: 'Plus Jakarta Sans, sans-serif'
            }} data-id="element-288">
                El Cierre Maestro
              </h3>
              <p style={{
              color: '#6B7280',
              fontFamily: 'Inter, sans-serif'
            }} className="text-base leading-relaxed" data-id="element-289">
                El mensaje estratégico para asegurar reseñas de 5 estrellas de
                forma ética. Sin rogar, sin presionar — solo el momento y las
                palabras correctas.
              </p>
            </div>
          </div>

          {/* Item 5 */}
          <div className="flex items-start gap-5 bg-white rounded-2xl p-6 shadow-sm border border-[#E8E0D8]" data-id="element-290">
            <div className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center text-2xl" style={{
            backgroundColor: '#FFF0F0'
          }} role="img" aria-label="Configuración" data-id="element-291">
              ⚙️
            </div>
            <div data-id="element-292">
              <h3 className="text-lg font-bold mb-1" style={{
              color: '#1A1A1A',
              fontFamily: 'Plus Jakarta Sans, sans-serif'
            }} data-id="element-293">
                Guía de Configuración en 10 Minutos
              </h3>
              <p style={{
              color: '#6B7280',
              fontFamily: 'Inter, sans-serif'
            }} className="text-base leading-relaxed" data-id="element-294">
                Cómo automatizar todo en la App de Airbnb en menos de 10
                minutos. Sin herramientas de pago, sin tecnicismos.
              </p>
            </div>
          </div>
        </div>

        {/* Value callout */}
        <div className="mt-10 rounded-2xl p-6 text-center border-2" style={{
        borderColor: '#FF5A5F',
        backgroundColor: '#FFF5F5'
      }} data-id="element-295">
          <p className="text-lg font-bold" style={{
          color: '#1A1A1A',
          fontFamily: 'Plus Jakarta Sans, sans-serif'
        }} data-id="element-296">
            Todo esto por un único pago de{' '}
            <span style={{
            color: '#FF5A5F'
          }} data-id="element-297">
              $6.39 USD
            </span>
          </p>
          <p style={{
          color: '#6B7280',
          fontFamily: 'Inter, sans-serif'
        }} className="text-sm mt-1" data-id="element-298">
            Sin suscripciones. Acceso de por vida. Descarga inmediata.
          </p>
        </div>
      </div>
    </section>;
}